import { gql, useLazyQuery } from '@apollo/client'
import { useEffect } from 'react'

import {
  GetExperimentParticipationQueryQuery,
  GetExperimentParticipationQueryQueryVariables,
} from './__generated__/use-one-click-success-experiment.graphql'

const GET_EXPERIMENT_PARTICIPATION_QUERY = gql`
  query GetExperimentParticipationQuery {
    root {
      participateExperiment(
        experimentGroup: "payments"
        experimentName: "one-click-success-screen"
        simulate: false
        onlySignedIn: true
      ) {
        participating
        alternative {
          name
        }
        experimentGroup {
          name
        }
        name
      }
    }
  }
`

type UseOneClickSuccessExperimentParams = {
  shouldFetch: boolean
  onResult: (enabled: boolean) => void
}

export function useOneClickSuccessExperiment({
  shouldFetch,
  onResult,
}: UseOneClickSuccessExperimentParams) {
  const [fetchExperiment, { data }] = useLazyQuery<
    GetExperimentParticipationQueryQuery,
    GetExperimentParticipationQueryQueryVariables
  >(GET_EXPERIMENT_PARTICIPATION_QUERY)

  useEffect(() => {
    if (shouldFetch && !data) {
      fetchExperiment()
    }
  }, [shouldFetch, data, fetchExperiment])

  useEffect(() => {
    if (!data) return
    const participating = data?.root?.participateExperiment?.participating
    const alternative = data?.root?.participateExperiment?.alternative?.name
    const shouldEnableSuccessScreen = !!participating && alternative === 'enable-success-screen'
    onResult(shouldEnableSuccessScreen)
  }, [data, onResult])
}

// Export the query for use in tests if needed
export { GET_EXPERIMENT_PARTICIPATION_QUERY }
